import Mock from "mockjs";
import {
 baseUrl
} from "../config";
import mockList from "./mergeList";

const useMock = false;

Mock.setup({
  timeout : 1000
})

mockList.forEach(item => {
  const {
    isMock,
    url,
    type = "post",
    template
  } = item;
  useMock && isMock && Mock.mock(RegExp(`${baseUrl}${url}.*`), type || "post", template);
})